'use client';

import { useEffect, useRef } from 'react';
import NextLink from 'next/link';

import ErrorImage from '@/assets/images/error.jpg';
import ContentMediaBlock from '@/components/content-media-block';
import MuiLegacyStyleProviders from '@/components/mui-legacy-style-providers';
import { SectionHeading } from '@/components/type';
import { Button } from '@/components/ui/button';
import URLS from '@/constants/urls';

export default function NotFound() {
  const wrapperRef = useRef<HTMLElement>(null);

  useEffect(() => {
    // Move focus to the page heading on mount so screen readers announce the route context.
    // ContentMediaBlock renders its `heading` prop as an h2 internally; querySelector is the
    // least invasive way to target it without forking ContentMediaBlock's API.
    const heading = wrapperRef.current?.querySelector<HTMLHeadingElement>('h2');
    if (heading) {
      heading.tabIndex = -1;
      heading.focus();
    }
  }, []);

  return (
    <main ref={wrapperRef} className="flex-1 bg-white">
      <MuiLegacyStyleProviders>
        <ContentMediaBlock
          imageOverride={ErrorImage}
          heading="Something went wrong..."
          imageOverrideAlt="Error Page"
          imageAlignment="right"
        >
          <SectionHeading>
            The page you are looking for may have been removed, had its name changed or is temporarily unavailable.
          </SectionHeading>
          <Button asChild className="mt-6 w-full lg:w-auto">
            <NextLink href={URLS.HOME}>Return home</NextLink>
          </Button>
        </ContentMediaBlock>
      </MuiLegacyStyleProviders>
    </main>
  );
}
